export var BenefitType;
(function (BenefitType) {
    /** Should never be used */
    BenefitType["UNDEFINED"] = "UNDEFINED";
    /** Limited benefit type */
    BenefitType["LIMITED"] = "LIMITED";
    /** Unlimited benefit type */
    BenefitType["UNLIMITED"] = "UNLIMITED";
})(BenefitType || (BenefitType = {}));
export var Event;
(function (Event) {
    Event["Updated"] = "Updated";
    Event["Deleted"] = "Deleted";
    Event["Created"] = "Created";
})(Event || (Event = {}));
export var PlanStatus;
(function (PlanStatus) {
    /** Should never be used */
    PlanStatus["UNDEFINED"] = "UNDEFINED";
    /** Active plan status */
    PlanStatus["ACTIVE"] = "ACTIVE";
    /** Archive plan status */
    PlanStatus["ARCHIVED"] = "ARCHIVED";
})(PlanStatus || (PlanStatus = {}));
//# sourceMappingURL=types.impl.js.map